import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0dfa67fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "mt-4"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please click on it to to confirm email change.", -1));
const _hoisted_4 = {
  class: "d-flex flex-row align-items-center justify-content-end gap-2"
};
const _hoisted_5 = {
  key: 1,
  class: "parent-div-profile-info"
};
const _hoisted_6 = {
  class: "d-flex flex-row align-items-center justify-content-end gap-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_input = _resolveComponent("app-input");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_app_card = _resolveComponent("app-card");
  return _openBlock(), _createBlock(_component_app_card, {
    loading: $data.dataLoading,
    title: "",
    scrollable: false
  }, {
    default: _withCtx(() => [$data.showConfirmationText ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, "A verification link has been sent to " + _toDisplayString($data.form.email) + ".", 1), _hoisted_3, _createElementVNode("div", _hoisted_4, [!$data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
      key: 0,
      variant: "outline-primary",
      onClick: _cache[0] || (_cache[0] = $event => $data.showConfirmationText = false)
    }, {
      default: _withCtx(() => [_createTextVNode(" Back to Settings ")]),
      _: 1
    })) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createVNode(_component_app_input, {
          modelValue: $data.form.first_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.first_name = $event),
          readonly: !$data.isEdit,
          validateRule: "name",
          type: "text",
          label: "First Name",
          placeholder: "Please enter your first name",
          required: "",
          onSubmit: $options.onSubmit
        }, null, 8, ["modelValue", "readonly", "onSubmit"])]),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createVNode(_component_app_input, {
          modelValue: $data.form.last_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.last_name = $event),
          readonly: !$data.isEdit,
          validateRule: "name",
          type: "text",
          label: "Last Name",
          placeholder: "Please enter your last name",
          required: "",
          onSubmit: $options.onSubmit
        }, null, 8, ["modelValue", "readonly", "onSubmit"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createVNode(_component_app_input, {
          modelValue: $data.form.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.email = $event),
          readonly: $data.isReadOnly,
          validateRule: "email",
          type: "email",
          label: "Email",
          placeholder: "Please enter your email",
          required: "",
          onSubmit: $options.onSubmit
        }, null, 8, ["modelValue", "readonly", "onSubmit"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [!$data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
          key: 0,
          variant: "outline-primary",
          onClick: $options.onEdit
        }, {
          default: _withCtx(() => [_createTextVNode(" Edit ")]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true), $data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
          key: 1,
          variant: "outline-primary",
          onClick: $options.onCancel
        }, {
          default: _withCtx(() => [_createTextVNode(" Cancel ")]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true), $data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
          key: 2,
          loading: $data.loading,
          onClick: $options.onSubmit
        }, {
          default: _withCtx(() => [_createTextVNode(" Save ")]),
          _: 1
        }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)])]),
        _: 1
      })]),
      _: 1
    })]))]),
    _: 1
  }, 8, ["loading"]);
}